import httpClient from "./httpClient";

const ReportService = {
  async overview() {
    return await httpClient.get("/report/overview");
  },

  async incidents(params = {}) {
    return await httpClient.get("/report/incidents", { params });
  },

  async members() {
    return await httpClient.get("/report/members");
  },

  async inventory() {
    return await httpClient.get("/report/inventory");
  }
};

export default ReportService;
